module.exports = __webpack_public_path__ + "static/media/14_humidity_poor_ko.f78ceb5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/14_humidity_poor_ko.png
// module id = 210
// module chunks = 0